import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import FileUploaderBody from '../../items/FileUploader';
import Gallery from '../../items/Gallery';
import IotmConfigScen from './IotmConfigScen';

//https://codesandbox.io/s/mouse-drawing-react-d3-i3y7m?file=/src/MouseDraw.js - рисовалка todo

import LangsSelector from '../../items/LangsSelector.js';

const Iotmpost = ({ eventLocal, setEventLocal, config }) => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <LangsSelector config={config}></LangsSelector>

      {/* Выбираем категорию*/}
      <div className='flex items-center justify-center'>
        <select
          value={eventLocal.category}
          onChange={(e) =>
            setEventLocal({
              ...eventLocal,
              category: e.target.value,
            })
          }
          className='select text-center select-sm select-success mb-6 w-1/2'>
          <option value='unknown' selected>
            {t('iotm.category.choose')}
          </option>
          <option value='water_supply'>{t('water_supply')}</option>
          <option value='climate_vent'>{t('climate_vent')}</option>
          <option value='heating'>{t('heating')}</option>
          <option value='mechanics'>{t('mechanics')}</option>
          <option value='power_supply'>{t('power_supply')}</option>
          <option value='monitoring_systems'>{t('monitoring_systems')}</option>
          <option value='other'>{t('other')}</option>
        </select>
      </div>

      {/* Редактируем заголовок*/}

      <p class='text-center mb-1 italic text-gray-600 text-sm'>{t('iotm.header.name')}</p>
      <input
        class='h-8 w-full content-center mb-4 border border-green-300 hover:border-blue-300 bg-gray-50 hover:bg-white text-gray-700 leading-tight focus:outline-none text-center'
        onChange={(e) =>
          setEventLocal({
            ...eventLocal,
            topic: { ...eventLocal.topic, [i18n.language]: e.target.value },
          })
        }
        value={eventLocal.topic[i18n.language]}></input>

      {/*Редактируем основной текст*/}
      <p class='text-center mb-1 italic text-gray-600 text-sm'>{t('iotm.header.descr')}</p>
      <textarea
        class='h-40 w-full content-center mb-4 p-2 border border-green-300 hover:border-blue-300 bg-gray-50 hover:bg-white text-gray-700 leading-tight focus:outline-none text-left'
        onChange={(e) =>
          setEventLocal({
            ...eventLocal,
            text: { ...eventLocal.text, [i18n.language]: e.target.value },
          })
        }
        value={eventLocal.text[i18n.language]}></textarea>

      {/*отображаем таблицу элементов*/}
      <IotmConfigScen event={eventLocal}></IotmConfigScen>

      {/*отображаем галерею*/}
      <Gallery event={eventLocal}></Gallery>

      {/* Загрузчик картинок галереи*/}
      <FileUploaderBody
        array={true}
        eventLocal={eventLocal}
        setEventLocal={setEventLocal}></FileUploaderBody>
    </>
  );
};

export default Iotmpost;
